import type { useI18n } from '@affine/i18n';

type TFunc = ReturnType<typeof useI18n>;

export type OfflineStatusCopyKind =
  | 'groups-online-only'
  | 'people-online-only'
  | 'settings-online-only'
  | 'share-load-online-only';

const OFFLINE_STATUS_COPY: Record<
  OfflineStatusCopyKind,
  {
    fallback: string;
    key: string;
  }
> = {
  'groups-online-only': {
    fallback: "Online required. Groups can't be searched or added offline.",
    key: 'com.streamlain.offline-status.groups-online-only',
  },
  'people-online-only': {
    fallback: "Online required. People can't be searched or added offline.",
    key: 'com.streamlain.offline-status.people-online-only',
  },
  'settings-online-only': {
    fallback: 'Offline, displayed data is incomplete.',
    key: 'com.streamlain.offline-status.settings-online-only',
  },
  'share-load-online-only': {
    fallback: "Online required. Sharing settings can't be loaded offline.",
    key: 'com.streamlain.offline-status.share-load-online-only',
  },
};

export function getOfflineStatusCopy(
  t: TFunc,
  kind: OfflineStatusCopyKind
): string {
  const copy = OFFLINE_STATUS_COPY[kind];
  return t[copy.key as keyof typeof t]?.() ?? copy.fallback;
}
